import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

class Navbar extends Component {
  state = { active: false, showHamburger: true };
  lastScrollY = 0;

  toggleSidebar = () => {
    this.setState({ active: !this.state.active });
  };

  closeSidebar = () => {
    this.setState({ active: false });
  };

  handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > this.lastScrollY && currentScrollY > 60) {
      this.setState({ showHamburger: false });
    } else {
      this.setState({ showHamburger: true });
    }
    this.lastScrollY = currentScrollY;
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    return (
      <Fragment>
        <nav id='sidebar' className={this.state.active ? 'active' : ''}>
          <div
            className='custom-menu'
            style={{
              opacity: this.state.active || this.state.showHamburger ? 1 : 0,
              pointerEvents:
                this.state.active || this.state.showHamburger ? 'auto' : 'none',
              transition: 'opacity 0.3s',
            }}
          >
            <button
              type='button'
              id='sidebarCollapse'
              className='btn btn-primary'
              onClick={this.toggleSidebar}
            >
              <i className={this.state.active ? 'fa fa-times' : 'fa fa-bars'} />
              <span className='sr-only'>Toggle Menu</span>
            </button>
          </div>
          <div className='p-4 pt-5'>
            <div className='bg-white ' style={{ borderRadius: 5 }}>
              <h1>
                <Link to='/' className='logo'>
                  <img
                    src='/images/logo.png'
                    alt='IT FIxed 247'
                    style={{ width: '100%' }}
                  />
                </Link>
              </h1>
            </div>
            <ul className='list-unstyled components mb-5'>
              <li>
                <Link to='/' onClick={this.closeSidebar}>
                  {' '}
                  <i className='fa fa-home'></i> Home{' '}
                </Link>
              </li>

              <li>
                <a
                  href='#printersolution'
                  data-toggle='collapse'
                  aria-expanded='false'
                  className='dropdown-toggle'
                >
                  <i className='fa fa-print'></i> Printer Solutions
                </a>
                <ul className='collapse list-unstyled' id='printersolution'>
                  <li>
                    <Link
                      to='/services/printer-setup'
                      onClick={this.closeSidebar}
                    >
                      Printer Setup{' '}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/services/printer-installation'
                      onClick={this.closeSidebar}
                    >
                      Printer Installation
                    </Link>
                  </li>

                  <li>
                    <Link
                      to='/services/printer-troubleshooting'
                      onClick={this.closeSidebar}
                    >
                      Printer Troubleshooting
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href='#pageSubmenu'
                  data-toggle='collapse'
                  aria-expanded='false'
                  className='dropdown-toggle'
                >
                  <i className='fa fa-wifi'></i> Router Solutions
                </a>
                <ul className='collapse list-unstyled' id='pageSubmenu'>
                  <li>
                    <Link
                      to='/services/wifi-and-network-connectivity'
                      onClick={this.closeSidebar}
                    >
                      WiFi and Network Connectivity{' '}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/services/set-up-a-new-wifi-connection'
                      onClick={this.closeSidebar}
                    >
                      New WiFi Connection Setup{' '}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/services/extend-a-wifi-signal'
                      onClick={this.closeSidebar}
                    >
                      WiFi Signal Extension
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href='#antivirus'
                  data-toggle='collapse'
                  aria-expanded='false'
                  className='dropdown-toggle'
                >
                  <i className='fa fa-shield'></i> Antivirus Solutions
                </a>
                <ul className='collapse list-unstyled' id='antivirus'>
                  <li>
                    <Link
                      to='/services/pc-optimization'
                      onClick={this.closeSidebar}
                    >
                      PC Optimization{' '}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/services/virus-removal-cleanup'
                      onClick={this.closeSidebar}
                    >
                      Virus Removal & Cleanup
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href='#ites'
                  data-toggle='collapse'
                  aria-expanded='false'
                  className='dropdown-toggle'
                >
                  <i className='fa fa-cloud'></i> ITES Services
                </a>
                <ul className='collapse list-unstyled' id='ites'>
                  <li>
                    <Link to='/network-security' onClick={this.closeSidebar}>
                      Network Security.{' '}
                    </Link>
                  </li>
                  <li>
                    <Link to='/cloud-computing' onClick={this.closeSidebar}>
                      Cloud Computing.
                    </Link>
                  </li>
                  <li>
                    <Link to='/managed-services' onClick={this.closeSidebar}>
                      Managed Services.
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  href='#computer'
                  data-toggle='collapse'
                  aria-expanded='false'
                  className='dropdown-toggle'
                >
                  <i className='fa fa-desktop'></i> Computer Solutions
                </a>
                <ul className='collapse list-unstyled' id='computer'>
                  <li>
                    <Link
                      to='/services/new-computer-setup'
                      onClick={this.closeSidebar}
                    >
                      New Computer Setup
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/services/computer-repair'
                      onClick={this.closeSidebar}
                    >
                      Computer Repair{' '}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/services/computer-tuneup'
                      onClick={this.closeSidebar}
                    >
                      Computer Tune-up
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/services/data-backup-or-transfer'
                      onClick={this.closeSidebar}
                    >
                      Data Back-up or Transfer
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  to='/services/operating-system-services'
                  onClick={this.closeSidebar}
                >
                  <i className='fa fa-wrench'></i> Operating System
                </Link>
              </li>
              <li>
                <Link to='/services/browser-setup' onClick={this.closeSidebar}>
                  <i className='fa fa-globe'></i> Browsers Setup
                </Link>
              </li>
              <li>
                <Link
                  to='/services/application-software'
                  onClick={this.closeSidebar}
                >
                  <i className='fa fa-briefcase'></i> Application Software
                </Link>
              </li>

              <li>
                <Link to='/about-us' onClick={this.closeSidebar}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to='/contact-us' onClick={this.closeSidebar}>
                  {' '}
                  Contact Us{' '}
                </Link>
              </li>
            </ul>

            <div className='footer'>
              <p>Copyright © 2020 IT Fixed 247</p>
            </div>
          </div>
        </nav>
      </Fragment>
    );
  }
}

export default Navbar;
